
import { useState } from 'react';
import { CardItem } from '@/components/admin/cards/CardForm';
import { useCategories } from '@/hooks/useCategories';

export const useCardDialog = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentCard, setCurrentCard] = useState<CardItem | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const { categories } = useCategories(true);

  const handleOpenDialog = (card?: CardItem) => {
    if (card) {
      setCurrentCard({ 
        ...card,
        insights: card.insights || []
      });
      setIsEditing(true);
    } else {
      // Initialize with default values for a new card
      // Generate a proper UUID rather than using a timestamp
      const uuid = crypto.randomUUID();
      
      // Get default category if available
      const defaultCategory = categories.length > 0 ? categories[0] : null;
      
      setCurrentCard({
        id: uuid,
        title: '',
        category: defaultCategory?.name || 'Uncategorized',
        category_id: defaultCategory?.id || null,
        agreePercentage: 50,
        totalPollsters: 0,
        description: '',
        status: 'draft',
        country_code: null,
        constituency_code: null,
        insights: []
      });
      setIsEditing(false);
    }
    setDialogOpen(true);
  };

  return {
    dialogOpen,
    setDialogOpen,
    currentCard,
    setCurrentCard,
    isEditing,
    handleOpenDialog
  };
};
